import { SceneManager } from '../model/SceneManager';

export function downloadScreenshot(filename: string = 'screenshot.png'): void {
    const gl = SceneManager.gl;
    if (!gl) {
        console.error('screenshotUtils: WebGLRenderer is not available.');
        return;
    }

    const dataUrl = gl.domElement.toDataURL('image/png');

    const link = document.createElement('a');
    link.href = dataUrl;
    link.download = filename;
    link.click();
}

export function captureScreenshotBlob(): Promise<Blob | null> {
    const gl = SceneManager.gl;
    if (!gl) {
        console.error('screenshotUtils: WebGLRenderer is not available.');
        return Promise.resolve(null);
    }
    return new Promise(resolve => gl.domElement.toBlob(resolve, 'image/png'));
}
